import {
  GST_REFUND_REPORT_REQUEST,
  GST_REFUND_REPORT_SUCCESS,
  GST_REFUND_REPORT_FAILURE,
} from "../types/gst-refund-report-types";

const initialState = {
  gstRefundReport: {},
  loading: false,
  error: null,
};

const gstRefundReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case GST_REFUND_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case GST_REFUND_REPORT_SUCCESS: {
      return {
        ...state,
        gstRefundReport: {...(action.payload || {})},
        loading: false,
        error: null
      };
    }
    case GST_REFUND_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default gstRefundReportReducer;
